.tools {
  position: absolute;
  display: flex;
  align-items: center;
  gap: 6px;
  pointer-events: all;
  font-size: 12px;
  font-weight: 600;
  z-index: 5;
}

.label {
  background: #fff;
  color: #d62a4a;
  padding: 2px 8px;
  border-radius: 999px;
  border: 1px solid #d62a4a;
  line-height: 1.4;
}

.delete {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: none;
  background: #d62a4a;
  color: #fff;
  font-size: 14px;
  line-height: 1;
  font-weight: 700;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition:
    opacity 120ms ease,
    transform 120ms ease;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}

.tools:hover .delete,
.selected .delete {
  opacity: 1;
}
.delete:hover {
  transform: scale(1.15);
}
